﻿import { preferences } from "./preferences";

$(() => {
	let $container = $("#main-container");

	$("#sidebar .toggle").on("click", () => {
		$container.toggleClass("open");
		$('body').trigger('toggled.sidebar.cmn'); // keep this, important

		preferences.sidebarOpened = !preferences.sidebarOpened;
	});
});

$(window).on("load", () => {
	let $window = $(window),
		$container = $("#main-container"),
		headerHeight = $("body > header").height();

	// Force sidebar closed unless on one of these pages
	const keepSidebarOpen = ["/reports", "/reports/taxreceipts", "/dashboard", "/profile"].includes(window.location.pathname);
	if (!keepSidebarOpen || $window.width() < 768) {
        setTimeout(() => {
            preferences.sidebarOpened = false;
            $container.removeClass("open");
        }, 1000);
	}

	let sidebarHeight = (() => {
		let $sizer = $("<div style='width: 285px; padding: 25px 45px; position: absolute; top: 0; left: -99999px;'>"),
			height = 0;

		$sizer.html($("#sidebar > div").html());

		$(window.document.body).append($sizer);

		height = $sizer.outerHeight(true);

		$sizer.remove();

		return height;
	})();

	function recalculate() {
		window.requestAnimationFrame(() => {
			$("#main-container").css("min-height", () => {
				return Math.max(sidebarHeight, $window.height() - headerHeight);
			});
		});
	};

	$window.on("resize", recalculate);

	recalculate();
});
